/**
 * [ File :: B_Tween.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/base/dev/animate/tween/B_Tween.js
 * @목적 : "TweenJS Wrapper Method"를 가지고 있음
 * @진행 : 개발종료
 * @주의 : 없음
 * @이슈 : 없음
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 : https://www.createjs.com/demos/tweenjs/tween_sparktable
 */

import BaseCanvas from 'canvas/base/dev/scripts/BaseCanvas';
import B_Define from 'canvas/base/dev/util/B_Define';

const B_Tween = (function () {

	return class extends BaseCanvas {
		constructor(canvas) { super(canvas); }

		/**
		 * [ Function :: tween ]
		 *
		 * @DES :: 애니메이션 기본형태 - 해당 프레임워크를 기반으로 애니메이션을 제작합니다.
		 * @IP1 :: obj {obj}
		 * @IP2 :: act {str}
		 * @IP3 :: tween {obj}
		 * @IP4 :: cb {func}
		 * @O.P :: tween {obj}
		 * @S.E :: act의 존재유무로 obj의 action을 실행할지 실행하지 않을 지를 결정합니다.
		 */
		tween(obj, act, tween, cb) {
			try {

				/**
				 * [SAMPLE]
				 *
				 * 01. obj : obj,
				 * 02. action : "action",
				 * 03. tween {
			     *      loop : bool,
			     *      override : bool,
			     *      arrStep : [
			     *          {
			     *              wait   : n,
			     *              option : {
			     *                  x : x,
			     *                  y : y,
			     *                  scaleX : x,
			     *                  scaleY : y,
			     *                  rotation : r,
			     *                  alpha : a
			     *              },
			     *              time   : n,
			     *              effect : "effect"
			     *          }
			     *      ]
			     * },
				 * 04. cb
				 * */

				/**
				 * [STEP]
				 *
				 * 01. 캐릭터 액션 요청 여부 확인 및 실행
				 * 02. 트윈 객체 생성 (loop, override 설정)
				 * 03. 트윈 행동 설정
				 * 04. 트윈 객체 콜백 설정
				 * */

				// /*[T]*/ console.log(obj._container);

				// [#] action 파라미터를 요청한 객체만 gotoAndPlay를 실행합니다.
				if (
					obj._strResType == B_Define.ARR_RES_TYPE[2]
					&&
					typeof act != 'undefined'
					&&
					act != ""
					&&
					act != null
				) obj._object.gotoAndPlay(act);

				// [#] tween object init
				const TWEEN_OBJECT = createjs.Tween.get(
					obj._container,
					{
						loop: tween.loop ? tween.loop : false,
						override: tween.override ? tween.override : false
					}
				);

				// [#] tween object play
				tween.arrStep.forEach((v) => {
					if (v.wait) TWEEN_OBJECT.wait(v.wait);
					else TWEEN_OBJECT.to(v.option, v.time, createjs.Ease[v.effect]);
				});

				// [#] tween object callback
				TWEEN_OBJECT.call(() => {
					// [#] tween storage 제거
					// TODO...

					if (cb) cb(TWEEN_OBJECT);
				});

				// [#] tween storage 저장
				// TODO...

				return TWEEN_OBJECT;

			} catch (e) {
				console.log(e);
			}
		}
	}
}());

export default B_Tween;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/animate/tween/B_Tween.js